// extracted by mini-css-extract-plugin
export var button = "success-story-module--button--d9c28";
export var introduction = "success-story-module--introduction--0ea92";
export var logo = "success-story-module--logo--6499b";
export var logoWrapper = "success-story-module--logoWrapper--fabb9";
export var section = "success-story-module--section--e5b30";
export var sections = "success-story-module--sections--5b959";
export var svg = "success-story-module--svg--4b87e";
export var technologies = "success-story-module--technologies--2c485";
export var text = "success-story-module--text--a5358";
export var title = "success-story-module--title--8d3ec";
export var wrapper = "success-story-module--wrapper--e6af8";